import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { AccountRegisterHistoryContext } from "./AccountRegisterHistoryContext";

const AccountRegisterHistoryDetail = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["account-register-history", "common", "user"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const types = [
        { label: "Công dân", value: "CITIZEN" },
        { label: "Người nước ngoài", value: "FOREIGN" },
    ];

    const accountRegisterHistoryContext = useContext(AccountRegisterHistoryContext);
    const { accountRegisterHistories, setAccountRegisterHistories, accountRegisterHistoryDialog, setAccountRegisterHistoryDialog, accountRegisterHistoryDetails, setAccountRegisterHistoryDetails } = accountRegisterHistoryContext;

    const hideDialog = () => {
        setAccountRegisterHistoryDialog(false);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "contents" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const fieldTemplate = (rowData) => {
        let title = null;
        if (rowData.field === "username") {
            title = "Số định danh";
        } else if (rowData.field === "fullName") {
            title = "Họ và tên";
        } else if (rowData.field === "phoneNumber") {
            title = "Số điện thoại";
        } else if (rowData.field === "email") {
            title = "Địa chỉ email";
        } else if (rowData.field === "type") {
            title = "Loại tài khoản";
        } else if (rowData.field === "enabled") {
            title = "Trạng thái";
        } else if (rowData.field === "level") {
            title = "Mức Tài khoản";
        } else if (rowData.field === "cardExpiredDate") {
            title = "Hạn thẻ CCCD";
        } else if (rowData.field === "status") {
            title = "Trạng thái tài khoản";
        } else {
            title = rowData.field;
        }

        return <>{title}</>;
    };

    const valueBeforeTemplate = (rowData) => {
        let value = "";
        if (rowData.valueBefore === "CITIZEN") {
            value = types[0].label;
        } else if (rowData.valueBefore === types[1].value) {
            value = types[1].label;
        } else if (rowData.valueBefore === "true") {
            value = "Đang hoạt động";
        } else if (rowData.valueBefore === "false") {
            value = "Ngừng hoạt động";
        } else {
            value = rowData.valueBefore;
        }
        return <>{value}</>;
    };

    const valueAfterTemplate = (rowData) => {
        let value = "";
        if (rowData.valueAfter === types[0].value) {
            value = types[0].label;
        } else if (rowData.valueAfter === types[1].value) {
            value = types[1].label;
        } else if (rowData.valueAfter === "true") {
            value = "Đang hoạt động";
        } else if (rowData.valueAfter === "false") {
            value = "Ngừng hoạt động";
        } else {
            value = rowData.valueAfter;
        }
        return <>{value}</>;
    };

    return (
        <Dialog visible={accountRegisterHistoryDialog} style={{ width: "50%" }} header={t("history.titleDetail").toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid text-left">
                    <div className="col-12 mt-2">
                        <DataTable
                            ref={dt}
                            value={accountRegisterHistoryDetails}
                            dataKey="stt"
                            className="datatable-responsive p-datatable-sm"
                            showGridlines
                            paginator
                            rows={10}
                            first={0}
                            totalRecords={accountRegisterHistoryDetails?.length | 0}
                            paginatorClassName="justify-content-start"
                            paginatorTemplate={paginatorTemplate}
                            emptyMessage="Không có dữ liệu"
                        >
                            <Column className="text-center" field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                            <Column field="field" header={t("history.field")} body={fieldTemplate} />
                            <Column field="valueBefore" header={t("history.valueBefore")} body={valueBeforeTemplate} />
                            <Column field="valueAfter" header={t("history.valueAfter")} body={valueAfterTemplate} />
                        </DataTable>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default AccountRegisterHistoryDetail;
